// extracted by mini-css-extract-plugin
export default {"main":"Catalogos_main__tHyv9"};